import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useGetMeQuery, useLogoutMutation } from "../features/api/apiSlice";
import { setCenterCall, setBackgroundAutoplay, setShowTranscripts } from "../features/callPlayer/callPlayerSlice";
import { IconMenu, IconActivity, IconSettings, IconLogout } from "./DemoIcons";
import DemoBell from "./DemoBell";
import DemoArchiveControl from "./DemoArchiveControl";

function DemoTopBar({ system, shortName, live, isConnected, archiveLabel, onLiveToggle, onArchivePick, onActivityToggle, activityVisible, socket }) {
  const dispatch = useDispatch();
  const { data: me } = useGetMeQuery();
  const [logout] = useLogoutMutation();
  const centerCall = useSelector((s) => s.callPlayer.centerCall);
  const backgroundAutoplay = useSelector((s) => s.callPlayer.backgroundAutoplay);
  const showTranscripts = useSelector((s) => s.callPlayer.showTranscripts);
  const [navOpen, setNavOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <header className="demo-topbar">
      <div className="demo-pop-wrap">
        <button className={"demo-icon-btn" + (navOpen ? " active" : "")} onClick={() => setNavOpen((o) => !o)} title="Menu" aria-label="Menu"><IconMenu /></button>
        {navOpen && (
          <>
            <div className="demo-pop-scrim" onClick={() => setNavOpen(false)} />
            <nav className="demo-pop demo-pop-nav" onClick={() => setNavOpen(false)}>
              <Link to="/">Home</Link>
              <Link to="/systems">Systems</Link>
              <Link to="/events">Events</Link>
              <Link to="/about">About</Link>
              {shortName && <Link to={`/system/${shortName}`}>Classic view</Link>}
            </nav>
          </>
        )}
      </div>

      <span className="demo-system-name">{system ? system.name : "System not found"}</span>

      <div className="demo-topbar-right">
        <button className={"demo-icon-btn" + (activityVisible ? " active" : "")} onClick={onActivityToggle} title="Activity" aria-label="Activity"><IconActivity /></button>

        <DemoArchiveControl live={live} isConnected={isConnected} archiveLabel={archiveLabel}
          onLiveToggle={onLiveToggle} onArchivePick={onArchivePick} />

        <DemoBell socket={socket} />

        <div className="demo-pop-wrap">
          <button className={"demo-icon-btn" + (settingsOpen ? " active" : "")} onClick={() => setSettingsOpen((o) => !o)} title="Settings" aria-label="Settings"><IconSettings /></button>
          {settingsOpen && (
            <>
              <div className="demo-pop-scrim" onClick={() => setSettingsOpen(false)} />
              <div className="demo-pop demo-pop-settings" onClick={(e) => e.stopPropagation()}>
                <label><input type="checkbox" checked={centerCall} onChange={(e) => dispatch(setCenterCall(e.target.checked))} /> Focus on playing call</label>
                <label><input type="checkbox" checked={backgroundAutoplay} onChange={(e) => dispatch(setBackgroundAutoplay(e.target.checked))} /> Background autoplay</label>
                <label><input type="checkbox" checked={showTranscripts} onChange={(e) => dispatch(setShowTranscripts(e.target.checked))} /> Show transcripts</label>
              </div>
            </>
          )}
        </div>

        {me && me.user && (
          <button className="demo-icon-btn" title={`Log out ${me.user}`} aria-label="Log out"
            onClick={async () => { await logout(); window.location.reload(); }}><IconLogout /></button>
        )}
      </div>
    </header>
  );
}

export default DemoTopBar;
